<script setup>
import { reactive, ref } from "vue";

import Http from "lib/modules/Http";

const props = defineProps(["authEmail", "locale", "locales", "rightItems"]);

const http = reactive(new Http());

const localesArray = [];
const showLogoutFailed = ref(false);
const showDrawer = ref(false);
const selectedLocale = ref(props.locale);

function logout() {
	http.delete("/api/login", () => {
		http.busy = true;
		location.reload();
	}, () => (showLogoutFailed.value = true));
}

function setLocale(locale) {
	location.pathname = location.pathname.replace(/^\/[a-z]+\/(.*)/i, `/${locale}/$1`);
}

for (const [key, value] of Object.entries(props.locales))
	localesArray.push({ locale_id: key, ...value });

</script>
<template>
	<UiSelect
		v-model="selectedLocale"
		:options="localesArray"
		:title="$gettext('Locale / Language')"
		class="round locale"
		option-value="locale_id"
		option-text="name"
		@update:model-value="setLocale($event)"
	/>
	<a href="my" class="vui-btn-fa-circle" :title="$gettext('My account')">
		<i class="fa-light fa-circle-user"></i>
	</a>
	<button
		:title="$gettext('Menu')"
		class="vui-btn-fa-circle"
		@click="showDrawer = true"
	>
		<i class="fa-light fa-circle-ellipsis-vertical"></i>
	</button>
	<UiDrawer v-if="showDrawer" right @close="showDrawer = false">
		<div class="vix-nav vui-menu">
			<template v-if="authEmail">
				<div class="logout" @click="logout()">
					<i class="fa-regular fa-right-from-bracket"></i>
					<div class="title">
						<div>{{ $gettext("Log out") }}</div>
						<div class="email">{{ authEmail }}</div>
					</div>
				</div>
				<hr>
			</template>
			<template v-if="rightItems.length > 0">
				<a v-for="item in rightItems" :href="item.url" class="right-item">
					<i :class="item.icon" class="fa-regular"></i>
					<span>{{ item.name }}</span>
				</a>
			</template>
			<a href="help">
				<i class="fa-regular fa-question"></i>
				<span>{{ $gettext("Help") }}</span>
			</a>
		</div>
	</UiDrawer>
	<UiDialog v-if="showLogoutFailed" :modal="http.busy" class="vix-nav-logout-failure" @close="showLogoutFailed = false">
		<h2>{{ $gettext("Logout failure") }}</h2>
		<div class="grid gap-16">
			<div :style="{ visibility: http.busy ? 'hidden' : 'visible' }">
				<i class="fa-solid fa-triangle-exclamation fa-lg vui-left vui-danger"></i>
				<span>{{ $gettext("Unable to log out: %1", http.error) }}</span>
			</div>
			<UiButton type="button" :disabled="http.busy" :busy="http.busy" class="justify-self-end" @click="logout()">{{ $gettext("Try again") }}</UiButton>
		</div>
	</UiDialog>
</template>
